import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { WIDGET_PAGE_NAME } from '../../constants/service/app/widgetConstants';
import WidgetHomeMenuContainer from '../../containers/widget/WidgetHomeMenuContainer';

const WidgetHomeMenuCreate = () => {
  return (
    <PageTemplate pageName={WIDGET_PAGE_NAME.WIDGET_HOME_MENU_CREATE}>
      <WidgetHomeMenuContainer />
    </PageTemplate>
  );
};

export default WidgetHomeMenuCreate;
